import {dateFormat} from '@shared/dateUtils';

export function getHHmmFormat(date: Date) {
  return dateFormat(date, 'HHmm');
}

export function getYYYYMMFormat(date: Date) {
  return dateFormat(date, 'yyyyMM');
}

export function getYYYYMMddFormat(date: Date) {
  return dateFormat(date, 'yyyyMMdd');
}

export function getYYYYMMddHHmmssFormat(date: Date) {
  return dateFormat(date, 'yyyyMMddHHmmss');
}
